import styled from "styled-components";
import { Bronze } from "./Frame/Bronze";
import { Silver } from "./Frame/Silver";
import { Gold } from "./Frame/Gold";
import { Diamond } from "./Frame/Diamond";

const Container = styled.div`
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 100%;
    height: auto;
  }

  .bottom-star,
  .star,
  .light-rays {
    animation: none !important;
    opacity: 1;
    transform: scale(1);
  }
`;

const FRAMES = {
  1: Bronze,
  2: Silver,
  3: Gold,
  4: Diamond,
};

export const BadgeXSmall = ({ level }) => {
  const Frame = FRAMES[level];
  if (!Frame) return null;

  return (
    <Container>
      <Frame />
    </Container>
  );
};
